const Item = ({ label, value, children }) => {
  
  return (!!value) ? <div>
    <label>{label}</label>
    <span>
      {value}
      {children}
    </span>
  </div> : null
}

export {Item};
